import waRequest from './wa-request';

const baseApi = '/cem-meta/v1';

function getDataset({pathParams, params}) {
  const {datasetUId} = pathParams;
  const url = `${baseApi}/datasets/${datasetUId}`;

  return waRequest.requestAuthenticated({url, method: 'GET', params});
}

function getDatasetSchema({pathParams, params}) {
  const {datasetUId} = pathParams;
  const url = `${baseApi}/datasets/${datasetUId}/schema`;

  return waRequest.requestAuthenticated({url, method: 'GET', params});
}

function queryDatasets({data}) {
  const url = `${baseApi}/datasets/query`;

  return waRequest.requestAuthenticated({url, method: 'POST', data});
}

export default {
  getDataset,
  getDatasetSchema,
  queryDatasets,
};
